var queue= [];

const addToQueue = function (method, params) {
    queue.push({
        func: method,
        data: params
    });
};

const executeQueuedFunctions = function () {
    if(queue.length){
        for(var i = 0; i < queue.length; i++){
            try{
                queue[i].func(queue[i].data);
            } catch(error){
                console.error(error);
            }
        }

        queue = [];
	}
};

export {executeQueuedFunctions, addToQueue};


// WEBPACK FOOTER //
// ./src/js/cms/util/queue.js